import ServiceGraphQL from 'src/service/gql-service';
import { getCompanyBankStatementUplaodUrl } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const GetCompanyBankStatementUploadUrl = (variables) => {
  const params = {
    query: getCompanyBankStatementUplaodUrl.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res.data.getBankStmtUploadUrl.url;
    })
    .catch((err) => {
      throw err;
    });
};
